import { Link } from 'react-router-dom'

export default function Home() {
  return (
    <div className="home-hero">
      <Link to="/about">
        <img
          src="/assets/uploads_1_2_8_8_12888984_4003140.jpg"
          alt="ALAMAR - traditional wooden schooner sailing the coast of Maine"
        />
      </Link>
    </div>
  )
}
